module.exports = __webpack_public_path__ + "static/img/8.f0b836f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/8.png
// module id = limc
// module chunks = 0